import script from "./goRinSyo0008.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0008.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0008.vue?vue&type=style&index=0&id=76e841ff&lang=scss"

const __exports__ = script;

export default __exports__